<div class="container">
    <div class="row d-flex justify-content-center">
        <div class="col-md-12 text-center main-title">
            <h1>Preferiti</h1>
        </div>
    </div>

    <div class="datatable mt-4">
        <h3>Lista preferiti</h3>
        
        <table class="table datatable-table" mdbTable mdbTableSort #table="mdbTable" #sort="mdbTableSort"
            [dataSource]="tableData" [sort]="sort">
            <thead class="datatable-header">
                <tr>
                    <th *ngFor="let header of headers" [mdbTableSortHeader]="header" scope="col">
                        {{ header | titlecase }}
                    </th>
                </tr>
            </thead>
            <tbody class="datatable-body">
                <tr *ngIf="loadingData">
                    <td colspan="9">
                        <div class="d-flex align-items-center text-center">
                            <strong>Loading...</strong>
                            <div class="spinner-border ms-auto" role="status" aria-hidden="true"></div>
                        </div>
                    </td>
                </tr>
                <tr *ngFor="let data of table.data" scope="row">
                    <td>{{data.market}}</td>
                    <td>{{data.verso}}</td>
                    <td>{{data.swing}}</td>
                    <td>{{data.dayweek}}</td>
                    <td>{{data.numprofit}}</td>
                    <td>{{data.profit | number : '1.4-4'}}</td>
                    <td>{{data.profit_re | number : '1.4-4'}}</td>
                    <td>{{data.profit_bt_euro | number : '1.4-4'}}</td>
                    <td>{{data.profit_euro | number : '1.4-4'}}</td>
                    <td>
                        <select name="preferito" [value]="data.preferito" (change)="updatePreferito(data, $event)">
                            <option value="nessuno">Nessuno</option>
                            <option value="break">Break</option>
                            <option value="retr">Retr</option>
                            <option value="entrambi">Entrambi</option>
                            </select>
                    </td>
                </tr>

            </tbody>
        </table>
    </div>
</div>